import axios from 'axios'
import issuance_request from '@/constants/issuance_request'

const issuance_request_own_index = {
  namespaced: true,

  state() {
    return {
      search_conditions: {
        id: null,
        status: issuance_request.status.WORKING.code,
        building_name: null,
        building_name_kana: null,
        request_at_from: null,
        request_at_to: null,
        transfer_notification_date_from: null,
        transfer_notification_date_to: null,
        transfer_confirm_date_from: null,
        transfer_confirm_date_to: null,
        issued_at_from: null,
        issued_at_to: null,
        expire_datetime_from: null,
        expire_datetime_to: null,
      },
      paginationStatus: {
        from: null,
        to: null,
        total: null,
        current_page: null,
        last_page: null,
        per_page: null,
      },
      sortStatus: {
        column: null,
        ascending: true,
      },
      issuance_requests: [],
      errors: {},
    };
  },

  getters: {
    getParameter(state) {
      return {
        ...state.search_conditions,
        sort_attribute: state.sortStatus.column,
        sort_direction: state.sortStatus.ascending ? 'asc' : 'desc',
        page: state.paginationStatus.current_page,
        per_page: state.paginationStatus.per_page,
      };
    }
  },
  mutations: {
    setData(state, data) {
      state.issuance_requests = data;
      state.errors = {};
    },
    setErrors(state, errors) {
      state.errors = {...errors};
    },
    inputSearchItem(state, payload) {
      if (state.search_conditions[payload.column] !== undefined) {
        state.search_conditions[payload.column] = payload.value;
      }
    },
    resetForms(state) {
      state.search_conditions.id = null;
      state.search_conditions.status = issuance_request.status.WORKING.code;
      state.search_conditions.building_name = null;
      state.search_conditions.building_name_kana = null;
      state.search_conditions.request_at_from = null;
      state.search_conditions.request_at_to = null;
      state.search_conditions.transfer_notification_date_from = null;
      state.search_conditions.transfer_notification_date_to = null;
      state.search_conditions.transfer_confirm_date_from = null;
      state.search_conditions.transfer_confirm_date_to = null;
      state.search_conditions.issued_at_from = null;
      state.search_conditions.issued_at_to = null;
      state.search_conditions.expire_datetime_from = null;
      state.search_conditions.expire_datetime_to = null;
    },
    setSortColumn(state, payload) {
      if (state.sortStatus.column === payload.column) {
        state.sortStatus.ascending = !state.sortStatus.ascending;
      } else {
        state.sortStatus.column = payload.column;
        state.sortStatus.ascending = true;
      }
      state.paginationStatus.current_page = 1;
    },
    setMeta(state, meta) {
      state.paginationStatus = {
        from: meta.from,
        to: meta.to,
        total: meta.total,
        current_page: meta.current_page,
        last_page: meta.last_page,
        per_page: meta.per_page,
      };
    },
    setCurrentPage(state, payload) {
      state.paginationStatus.current_page = payload.value;
    },
    setPerPage(state, payload) {
      state.paginationStatus.per_page = payload.value;
    },
  },

  actions: {
    load({commit, getters}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/issuance_requests/me', {params: getters.getParameter}).then((response) => {
          commit('setData', response.data.data);
          commit('setMeta', response.data.meta);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    },
  }
};

export default issuance_request_own_index;
